<template>
  <div class="content">
    <!-- 顶部横幅 -->
    <div class="banner-section">
      <img src="../assets/img/sjzy/sjzy1.png" alt="" class="banner-image">
      <div class="banner-overlay">
        <div class="banner-inner">
          <div class="banner-text-wrapper">
            <h1 class="banner-title">科创金融</h1>
          </div>
          <!-- 右侧咨询表单 -->
          <div class="consultation-form">
            <div class="form-header">
              <h3 class="form-title">咨询服务</h3>
              <span class="form-badge">在线申请</span>
            </div>
            <el-form ref="form" :model="form" label-position="top">
              <el-form-item label="企业名称">
                <el-input v-model="form.name1" placeholder="请输入企业名称"></el-input>
              </el-form-item>
              <el-form-item label="联系人">
                <el-input v-model="form.name2" placeholder="请输入姓名"></el-input>
              </el-form-item>
              <el-form-item label="联系电话">
                <el-input v-model="form.name3" placeholder="请输入您的联系电话"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" class="submit-btn" @click="onSubmit">
                  提交申请
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" style="margin-left: 8px;">
                    <path d="M6 4L10 8L6 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>

    <!-- 移除独立咨询区块 -->

    <!-- 服务选项卡 -->
    <div class="services-section">
      <div class="services-tabs">
        <button 
          v-for="(item, index) in tablists.slice(0, 3)" 
          :key="index"
          :class="['service-tab', { 'active': tabis === item }]"
          @click="tabchange(item)"
        >
          <svg v-if="index === 0" class="tab-icon" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <rect x="3" y="4" width="14" height="12" rx="1" stroke="currentColor" stroke-width="1.5"/>
            <path d="M7 8h6M7 11h4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
          <svg v-else-if="index === 1" class="tab-icon" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <rect x="4" y="3" width="12" height="14" rx="1" stroke="currentColor" stroke-width="1.5"/>
            <path d="M8 7h4M8 10h3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
            <circle cx="10" cy="14" r="1.5" fill="currentColor"/>
          </svg>
          <svg v-else class="tab-icon" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <rect x="3" y="5" width="14" height="10" rx="1" stroke="currentColor" stroke-width="1.5"/>
            <path d="M7 9h6M7 12h4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
          <span class="tab-text">{{ item }}</span>
        </button>
      </div>

      <!-- 服务内容区域 -->
      <div class="services-content">
        <!-- 技术融资服务 -->
        <div v-if="tabis === '技术融资服务'" class="service-items">
          <div class="service-item">
            <div class="item-number">01</div>
            <div class="item-content">
              <h4 class="item-title">股权融资</h4>
              <p class="item-description">
                对接天使投资、VC/PE机构，开发"技术项目路演-投资意向对接-尽职调查"线上通道，针对初创期技术团队推出"技术估值+股权设计"打包服务。
              </p>
            </div>
          </div>

          <div class="service-item">
            <div class="item-number">02</div>
            <div class="item-content">
              <h4 class="item-title">债权融资</h4>
              <p class="item-description">
                联合国有银行开发"技术贷"产品，以专利、软件著作权等知识产权质押为核心，配套政府风险补偿基金，降低企业融资门槛。
              </p>
            </div>
          </div>

          <div class="service-item">
            <div class="item-number">03</div>
            <div class="item-content">
              <h4 class="item-title">政策性融资</h4>
              <p class="item-description">
                整合河南省"科技贷""专精特新贷"等政策资源，设置绿色通道对接国家中小企业发展基金、先进制造产业投资基金等国家级资金。
              </p>
            </div>
          </div>
        </div>

        <!-- 知识产权金融服务 -->
        <div v-if="tabis === '知识产权金融服务'" class="service-items">
          <div class="service-item">
            <div class="item-number">01</div>
            <div class="item-content">
              <h4 class="item-title">知识产权质押</h4>
              <p class="item-description">
                通过专利价值动态评估模型提供快速确权、评估、质押全流程服务，试点"专利池质押"模式（如种业专利组合、新材料专利集群）。
              </p>
            </div>
          </div>

          <div class="service-item">
            <div class="item-number">02</div>
            <div class="item-content">
              <h4 class="item-title">知识产权保险</h4>
              <p class="item-description">
                提供全面的知识产权保险，覆盖技术交易中的法律风险，降低企业维权成本。
              </p>
            </div>
          </div>

          <div class="service-item">
            <div class="item-number">03</div>
            <div class="item-content">
              <h4 class="item-title">知识产权证券化</h4>
              <p class="item-description">
                筛选高价值专利组合发行ABS产品，盘活存量技术资产。
              </p>
            </div>
          </div>
        </div>

        <!-- 金融产品 -->
        <div v-if="tabis === '金融产品'" class="products-section">
          <el-table
            v-loading="loading"
            element-loading-text="加载中..."
            element-loading-background="rgba(255, 255, 255, 0.9)"
            empty-text="暂无数据"
            :data="tableData"
            style="width: 100%"
            :header-cell-style="{ 
              backgroundColor: '#F9FAFB', 
              color: '#6B7280', 
              fontSize: '14px', 
              fontWeight: '500',
              borderBottom: '1px solid #E5E7EB'
            }"
            :cell-style="{ 
              borderBottom: '1px solid #F3F4F6',
              color: '#374151',
              fontSize: '14px'
            }"
          >
            <el-table-column prop="name" label="产品名称" show-overflow-tooltip align="left" min-width="300">
            </el-table-column>
            <el-table-column label="金融机构" align="center" min-width="200" show-overflow-tooltip>
              <template #default="scope">{{ scope.row.financialName }}</template>
            </el-table-column>
          </el-table>

          <!-- 分页 -->
          <div class="pagination-wrapper" v-if="listnum > 0">
            <div class="pagination-info">共 {{ listnum }} 条数据</div>
            <el-pagination
              class="custom-pagination"
              :page-size="5"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              background
              layout="prev, pager, next"
              :total="listnum"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAction, postAction } from '@/api/requests'
import Cookies from 'js-cookie'

export default {
  name: 'kcjrContent',
  components: {},
  props: {
    idsss: {
      type: String,
      default: ''
    },
    initialTab: {
      type: String,
      default: ''
    }
  },
  data(){
    return{
      listnum:0,
      tableData:[],
      loading:false,
      tablists:['技术融资服务','知识产权金融服务','金融产品','咨询服务'],
      tabis:'技术融资服务',
      form: {
        name1: '',
        name2: '',
        name3: '',
      }
    }
  },
  mounted(){
    // 如果有传入初始tab，则使用传入的tab
    if (this.initialTab && this.tablists.includes(this.initialTab)) {
      this.tabis = this.initialTab
    }
    this.getzjsjlist()
    this.prefillUserInfo()
  },
  watch: {
    initialTab: {
      handler(newVal) {
        if (newVal && this.tablists.includes(newVal)) {
          this.tabis = newVal
          if (newVal === '金融产品') {
            this.getzjsjlist()
          }
        }
      },
      immediate: false
    }
  },
  methods:{
    prefillUserInfo() {
      const token = Cookies.get('Admin-Token')
      if (!token) return
      getAction('/getInfo').then(res => {
        if (res.code === 200) {
          const u = res.user || {}
          this.form.name1 = u.enterpriseName || (u.dept && u.dept.deptName) || ''
          this.form.name2 = u.nickName || u.userName || ''
          this.form.name3 = u.phonenumber || ''
        }
      }).catch(() => {})
    },
    onSubmit() {
      if (!this.form.name1 || !this.form.name2 || !this.form.name3) {
        this.$message.warning('请填写完整信息')
        return
      }
      postAction('/trade/project_consult/submit', {
        consultDeptName: this.form.name1,
        contactName: this.form.name2,
        contactPhone: this.form.name3,
        consultType: 'finance'
      }).then(res => {
        if (res.code === 200) {
          this.$message.success('提交成功，我们会尽快与您联系！')
          this.form.name1 = ''
          this.form.name2 = ''
          this.form.name3 = ''
        } else {
          this.$message.error(res.msg || '提交失败')
        }
      }).catch(() => {
        this.$message.error('提交失败，请稍后重试')
      })
    },
    getzjsjlist(e=1){
      this.loading = true
      let data = {
        pageNum: e,
        pageSize: 5,
      }
      getAction("/edu/finance/product/list", data).then(res => {
        this.listnum = res.total
        this.tableData = res.rows
        this.loading = false
        console.log(res)
      })
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.getzjsjlist(val)
      console.log(`当前页: ${val}`);
    },
    tabchange(item){
      this.tabis = item
      if(item=='金融产品'){
        this.getzjsjlist()
      }
    }
  }
}
</script>

<style scoped>
.content {
  width: 100%;
  min-height: calc(100vh - 196px);
  background: #F5F7FA;
}

/* 顶部横幅 */
.banner-section {
  position: relative;
  width: 100%;
  height: 400px;
  overflow: hidden;
}

.banner-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.banner-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(90deg, rgba(10, 14, 26, 0.85) 0%, rgba(10, 14, 26, 0.6) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.banner-inner {
  width: 1200px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 80px;
}

.banner-text-wrapper {
  flex: 1;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.banner-title {
  font-size: 36px;
  font-weight: 600;
  color: #FFFFFF;
  margin: 0;
  padding-left: 380px;
}

.description {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.85);
  line-height: 1.8;
  margin: 0 0 24px 0;
  max-width: 500px;
}

.title-line {
  width: 80px;
  height: 4px;
  background: #155DFC;
  border-radius: 2px;
}

/* 右侧咨询表单 */
.consultation-form {
  width: 308px;
  height: 318px;
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(10px);
  box-shadow: 0px 7px 9px -5px rgba(28, 57, 142, 0.05), 0px 17px 22px -4px rgba(28, 57, 142, 0.05);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.5);
  padding: 24px;
  display: flex;
  flex-direction: column;
}

.form-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
}

.form-title {
  font-size: 20px;
  font-weight: 600;
  color: #1F2937;
  margin: 0;
}

.form-badge {
  padding: 3px 10px;
background: #F1F5F9;
  color: #90A1B9 ;
  font-size: 12px;
  border-radius: 12px;
  font-weight: 500;
}

.consultation-form :deep(.el-form) {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.consultation-form :deep(.el-form-item) {
  margin-bottom: 16px;
}

.consultation-form :deep(.el-form-item:last-child) {
  margin-bottom: 0;
  margin-top: auto;
}

.consultation-form :deep(.el-form-item__label) {
  font-size: 13px;
  color: #4B5563;
  font-weight: 500;
  margin-bottom: 6px;
  padding: 0;
  line-height: 1.5;
}

.consultation-form :deep(.el-input__wrapper) {
  border-radius: 8px;
  box-shadow: none;
  border: 1px solid #E5E7EB;
  padding: 3px 12px;
  background: #FFFFFF;
  transition: all 0.3s;
}

.consultation-form :deep(.el-input__wrapper:hover) {
  border-color: #155DFC;
}

.consultation-form :deep(.el-input__wrapper.is-focus) {
  border-color: #155DFC;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.consultation-form :deep(.el-input__inner) {
  font-size: 13px;
  color: #1F2937;
}

.consultation-form :deep(.el-input__inner::placeholder) {
  color: #9CA3AF;
  font-size: 13px;
}

.submit-btn {
  width: 100%;
  height: 40px;
  background: #155DFC;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 500;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s;
}

.submit-btn:hover {
  background: #2563EB;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.4);
}

/* 服务选项卡区域 */
.services-section {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 60px 0;
  background: #FFFFFF;
}

.services-tabs {
  display: flex;
  gap: 0;
  margin-bottom: 48px;
  background: #F3F4F6;
  border-radius: 50px;
  padding: 10px;
}

.service-tab {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 32px;
  background: transparent;
  border: none;
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.3s;
  font-size: 15px;
  color: #9CA3AF;
  font-weight: 500;
  position: relative;
}

.service-tab:hover {
  color: #6B7280;
}

.service-tab.active {
  background: #155DFC;
  color: #FFFFFF;
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.3);
}

.tab-icon {
  font-size: 18px;
  font-weight: 400;
}

.service-tab.active .tab-icon {
  font-weight: 600;
}

.tab-text {
  font-size: 15px;
}

/* 服务内容区域 */
.services-content {
  width: 1200px;
  background: #FFFFFF;
  border-radius: 12px;
  padding: 48px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  position: relative;
}

.services-content::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 48px;
  right: 48px;
  height: 3px;
  background: linear-gradient(90deg, #155DFC 0%, #60A5FA 100%);
  border-radius: 2px;
}

.service-items {
  display: flex;
  flex-direction: column;
  gap: 40px;
}

.service-item {
  display: flex;
  gap: 20px;
  padding: 0;
  background: transparent;
  border: none;
  border-radius: 0;
  transition: none;
}

.service-item:hover {
  border-color: transparent;
  box-shadow: none;
  transform: none;
}

.item-number {
  flex-shrink: 0;
  width: auto;
  height: auto;
  background: transparent;
  border-radius: 0;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  font-size: 18px;
  font-weight: 600;
  color: #155DFC;
  padding-top: 2px;
}

.item-content {
  flex: 1;
}

.item-title {
  font-size: 18px;
  font-weight: 600;
  color: #1F2937;
  margin: 0 0 16px 0;
}

.item-description {
  font-size: 14px;
  color: #6B7280;
  line-height: 1.8;
  margin: 0;
}

/* 金融产品区域 */
.products-section {
  background: #FFFFFF;
  border-radius: 12px;
  padding: 32px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.pagination-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid #E5E7EB;
}

.pagination-info {
  font-size: 14px;
  color: #6B7280;
}

.custom-pagination {
  display: flex;
  justify-content: center;
}
</style>
